import { style } from '@vanilla-extract/css';

export const embedDescriptionContainer = style({
  color: 'var(--wt-hyperlink-description-color)',
  paddingBottom: '6px',
  textAlign: 'left',
});

export const embedDescriptionContainerEmailEditor = style({
  paddingBottom: '6px',
});

export const embedDescriptionParagraph = style({
  fontFamily: 'var(--wt-hyperlink-font, var(--wt-hyperlink-font-family, inherit))',
  fontSize: 'var(--wt-hyperlink-description-size, 16px)',
  lineHeight: 'var(--wt-generic-embed-description-line-height, 24px)',
  margin: '0',
});
